import React, { FunctionComponent } from "react";
import { BedapDownAlert, ExtraHelpCard } from "../components";
import {
  CONSTANTS,
  getLowIncomeSubsidyStatusLabel,
  useTranslate,
} from "../../../helpers";
import { LowIncomeSubsidyStatus, UserLanguage } from "../../../@types";
import { isLowIncomeSubsidyStatusLabelAvailable } from "../../../helpers/planDataUtils";

interface ExtraHelpCardContainerProps {
  lis: LowIncomeSubsidyStatus | undefined;
  futureLis: LowIncomeSubsidyStatus | undefined;
  year: string;
  language: UserLanguage;
  isBEDAPDown: boolean;
}

const ExtraHelpCardContainer: FunctionComponent<ExtraHelpCardContainerProps> = ({
  year,
  lis,
  futureLis,
  language,
  isBEDAPDown,
}) => {
  const t = useTranslate();
  const nextYear = parseInt(year, 10) + 1;
  const currentLisText =
    lis &&
    isLowIncomeSubsidyStatusLabelAvailable(year.toString(), lis) &&
    t(getLowIncomeSubsidyStatusLabel(year.toString(), lis));
  const futureLisText =
    futureLis &&
    isLowIncomeSubsidyStatusLabelAvailable(nextYear.toString(), futureLis) &&
    t(getLowIncomeSubsidyStatusLabel(nextYear.toString(), futureLis));

  return (
    <div>
      <p className="ds-u-measure--base ds-u-font-size--lg ds-u-margin-top--0">
        {t("summary_page.extra_help.description")}{" "}
        <a
          href={CONSTANTS.linkToGetHelpPayingCosts(language)}
          className="mct-hide-print"
        >
          {t("summary_page.links.extra_help_details")}
        </a>
      </p>
      <div className="mct-c-extra-help-cards-container">
        {isBEDAPDown ? (
          <BedapDownAlert region="lis" />
        ) : (
          <>
            {currentLisText && (
              <ExtraHelpCard year={year} lisText={currentLisText} />
            )}
            {futureLisText && (
              <ExtraHelpCard year={nextYear} lisText={futureLisText} />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ExtraHelpCardContainer;
